import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../reducers'

export const getClientStore = (state: RootState) => state.client
export const getClientSearchState = (state: RootState) =>
  state.devices.searchState
export const getListClients = (state: RootState) => state.client.listClientsData
export const getSelectedClient = (state: RootState) =>
  state.client.selectedClient
export const getClientLoading = (state: RootState) => state.client.loading
export const getClientDetailLoading = (state: RootState) =>
  state.client.detailLoading
export const getClientSubmitting = (state: RootState) => state.client.submitting
export const getClientError = (state: RootState) => state.client.error

export const getClientOptions = createSelector([getListClients], clients =>
  clients.map(client => ({
    label: client.clientName,
    value: client.clientId,
  })),
)

